// import React from 'react'
// import { makeStyles } from '@material-ui/core/styles';
// import MentorItem from './MentorItem';

// const useStyles = makeStyles({
//     mentorSection: {
//         paddingTop: '80px',
//         paddingBottom: '80px',
//         '@media only screen and (max-width: 768px)': {
//             paddingTop: '60px',
//             paddingBottom: '60px',
//         },
//         '@media only screen and (max-width: 480px)': {
//             paddingTop: '40px',
//             paddingBottom: '40px',
//         },
//     },
//     mentorHeader: {
//         textAlign: 'center',
//         paddingBottom: '30px',
//     },
//     mentorBody: {

//     },
// })

// function Mentor() {

//     var classes = useStyles()

//     return (
//         <div className={classes.mentorSection}>
//             <div className="container">
//                 <div className={classes.mentorHeader}>
//                     <h1>Our Experts</h1>
//                     {/* <p>We are being supported by the best minds in the industry</p> */}
//                 </div>
//                 <div className={classes.mentorBody}>
//                     <div className="row" style={{justifyContent: 'center'}}>
//                         <div className="col-lg-3 col-md-4 col-6">
//                             <MentorItem image="/pitchbattle/images/Ankit-Machhar.jpg" name="Ankit Machhar" designation="Head - Ecosystem Development, Wadhwani Foundation"/>
//                         </div>
//                         <div className="col-lg-3 col-md-4 col-6">
//                             <MentorItem image="/pitchbattle/images/Swarup_Pandya.jpg" name="Swarup Pandya" designation="Regional Manager, Wadhwani Foundation"/>
//                         </div>
//                         <div className="col-lg-3 col-md-4 col-6">
//                             <MentorItem blur={1}  image="/pitchbattle/images/Ankit-Machhar.jpg" name="Ankit Machhar" designation="Head - Ecosystem Development, Wadhwani Foundation"/>
//                         </div>
//                         <div className="col-lg-3 col-md-4 col-6">
//                             <MentorItem blur={1}  image="/pitchbattle/images/Ankit-Machhar.jpg" name="Ankit Machhar" designation="Head - Ecosystem Development, Wadhwani Foundation"/>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Mentor
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MentorItem from './MentorItem';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const useStyles = makeStyles({
    mentorSection: {
        paddingTop: '80px',
        paddingBottom: '80px',
        '@media only screen and (max-width: 768px)': {
            paddingTop: '60px',
            paddingBottom: '60px',
        },
        '@media only screen and (max-width: 480px)': {
            paddingTop: '40px',
            paddingBottom: '40px',
        },
    },
    mentorHeader: {
        textAlign: 'center',
        paddingBottom: '30px',
    },
    mentorBody: {
        maxWidth: '1200px',
        margin: '0 auto',
        // Ensure touch events are enabled
        touchAction: 'pan-y',
        '-ms-touch-action': 'pan-y',
    },
    slide: {
        outline: 'none', // Removes outline when slide is focused
    },
});

function Mentor() {
    var classes = useStyles();

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true, 
        touchMove: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div className={classes.mentorSection}>
            <div className="container">
                <div className={classes.mentorHeader}>
                    <h1>Bootcamp Mentors & Experts</h1>
                </div>
                <div className={classes.mentorBody}>
                    <Slider {...settings}>
                        <div>
                            <MentorItem image="/pitchbattle/images/anupam.jpeg" name="Anupam Lavania" designation="Founder, Bioscan Research" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/mukesh.jpeg" name="Mukesh Kestwal" designation="Chief Innovation Officer, AWaDH @ IIT Ropar" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/deepak.jpeg" name="Dr. Deepak Motwani" designation="Principal - Investor Relations, Wadhwani Foundation" />
                            {/* <MentorItem blur={1} image="/pitchbattle/images/Ankit-Machhar.jpg" name="Ankit Machhar" designation="Head - Ecosystem Development, Wadhwani Foundation" /> */}
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/suraj.jpeg" name="Suraj Singh" designation="Startup Evangelist" />
                            {/* <MentorItem blur={1} image="/pitchbattle/images/Ankit-Machhar.jpg" name="Ankit Machhar" designation="Head - Ecosystem Development, Wadhwani Foundation" /> */}
                        </div>
                        
                        <div>
                            <MentorItem image="/pitchbattle/images/amrit.jpeg" name="Amrit Tiwari" designation="Head Investments, IIM Lucknow EIC" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/Ankit-Machhar.jpg" name="Ankit Machhar" designation="Director - Ecosystem, Wadhwani Foundation" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/ronald.jpeg" name="Ronald Fernandez" designation="CEO, AIC-RNTU" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/puneet.jpeg" name="Puneet Madaan" designation="Principal - Portfolio Growth and Exits, Realtime" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/kalpit.jpeg" name="Kalpit Shah" designation="Software Engineer, AllEvents" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/Swarup_Pandya.jpg" name="Swarup Pandya" designation="Manager - Seed Investments, IIMA Ventures" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/jigar.jpeg" name="Jigar Jiwani" designation="Program Manager, Venture Studio" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/gaurav.jpg" name="Gaurav Gupta" designation="Founder, AssetIn" />
                        </div>
                        <div>
                            <MentorItem image="/pitchbattle/images/hemang.jpg" name="Hemang Mehta" designation="Business Consultant" />
                        </div>
                      
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default Mentor;
